import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect } from 'react';
import { IntercomService, IntercomState } from '../IntercomService';

export const IntercomUXAdapter: React.FC = () => {
    const intercomService = useInstance(IntercomService);
    const intercomState = useInstance(IntercomState);

    useEffect(() => {
        intercomService.on('onShow', () => {
            document.body.classList.add('show-intercom');
        });

        intercomService.on('onHide', () => {
            setTimeout(() => {
                document.body.classList.remove('show-intercom');
            }, 500);
        });

        intercomService.on('onUnreadCountChange', (count: number) => {
            intercomState.setState({ unreadCount: count });
        });
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
